function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagBJ(props) {
  return /*#__PURE__*/React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURf3SOv/VRBKMVxSXXhWiZesdOe0gPOkaNu8iPvAkQOgYNPEmQRjNIc0AAAFSSURBVDjL5Y0xboQwEEWHG5gr4BtgbgAHSMPSbgOi3AZZotoKQZcSRJMOaau0KJfLzBiWNXg3qdLkaRgj/vMHkgf8IwL+oSCE8D3f9wQPvYhdgyC8FfDxgTiJcDDFA4TBe9jAeYwkUYQXhAe8aHBhQ7SR0GcrxwWxgYQYMOaQWY6tQKn1m7kNXIANkaKJccCFUsbABrdA1bFSuPEX7gZjUMsTgeCCV4L6nfA1EPM43vfwaQmcj+M8D3fej4LNIshQhc8ESXAuZd+2XTcMfd91Pb4TV2oIqUFKpdojV24IETSkUwjXFCmbplyeoijLtm2aMwQyCHGY4sgZllyS6BakUchwCgFhDBLy/HTa4lNOv8CQLWzI8zQlgTSjLg2UIumRt1UI/kioskzrqkrTLFu3LWiKNVOxrPXFFjK957JveC3cpqmubwid06R1XX/YwpGfhW8zRlv7D//kDQAAAABJRU5ErkJggg==",
    alt: "BJ"
  }, props));
}